import { Link, useSearchParams } from "react-router-dom";
import { Mail, Phone, MessageCircle, MapPin } from "lucide-react";
import { useSite } from "../../context/SiteContext";
import { img, waLink } from "../../lib/api";
import { useSeo, pageSeo } from "../../lib/seo";
import { PageHero } from "../../components/site/Bits";
import { EnquiryForm } from "../../components/site/Forms";

export function About() {
  const { site } = useSite();
  const a = site?.about || {};
  useSeo(pageSeo(site, "about", { title: a.title || "About Us", description: site?.brand?.tagline }), [site]);
  return (
    <>
      <PageHero eyebrow="Our story" title={a.title || "About Us"} image={a.image} />
      <section className="py-24 bg-white"><div className="container-x grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-7"><p className="text-lg leading-relaxed text-[#333] whitespace-pre-line" data-testid="about-body">{a.body}</p></div>
        <div className="lg:col-span-5"><div className="border border-black p-8"><p className="font-deva text-4xl font-bold">{site?.brand?.name_local}</p><p className="mt-3 text-[#666]">{site?.brand?.tagline}</p><Link to="/contact" className="btn-primary mt-8">Talk to us</Link></div></div>
      </div></section>
    </>
  );
}

export function Contact() {
  const { site } = useSite();
  const [sp] = useSearchParams();
  const c = site?.contact || {};
  const p = site?.contact_page || {};
  useSeo(pageSeo(site, "contact", { title: p.title || "Contact Us", description: p.body }), [site]);
  return (
    <>
      <PageHero eyebrow={sp.get("plan") ? "Plan your trip" : "Get in touch"} title={sp.get("plan") ? "Plan Your Trip" : p.title || "Contact Us"} text={p.body} image="/images/tours.jpg" />
      <section className="py-20 bg-white"><div className="container-x grid lg:grid-cols-12 gap-12">
        <div className="lg:col-span-4 space-y-6">
          <Info icon={Mail} label="Email" v={c.email} href={`mailto:${c.email}`} />
          <Info icon={Phone} label="Phone" v={c.phone} href={`tel:${c.phone}`} />
          <Info icon={MessageCircle} label="WhatsApp" v={site?.whatsapp?.number ? "Chat with us" : "Chat with us"} href={waLink(site?.whatsapp?.number, site?.whatsapp?.default_message)} />
          {c.address && <Info icon={MapPin} label="Address" v={c.address} />}
          {c.hours && <p className="text-sm text-[#666]">{c.hours}</p>}
          {c.map_embed_url && <iframe title="Map" src={c.map_embed_url} className="w-full h-64 border border-[#E5E5E5] grayscale" loading="lazy" />}
        </div>
        <div className="lg:col-span-8 card p-6 sm:p-10"><h2 className="font-display text-3xl font-bold mb-8">Send an enquiry</h2><EnquiryForm /></div>
      </div></section>
    </>
  );
}

const Info = ({ icon: I, label, v, href }) => (
  <div className="flex gap-4 border-b border-[#E5E5E5] pb-5"><I className="h-5 w-5 mt-1" /><div><p className="eyebrow">{label}</p>{v ? (href ? <a href={href} target={href.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer" className="font-semibold hover:underline">{v}</a> : <p className="font-semibold">{v}</p>) : <p className="text-[#666]">[Add in Admin → Content]</p>}</div></div>
);

const POLICY = { privacy: "Privacy Policy", terms: "Terms and Conditions", cancellation: "Cancellation and Refund Policy" };
export function Policy({ k }) {
  const { site } = useSite();
  useSeo(pageSeo(site, k, { title: POLICY[k] }), [site, k]);
  return (
    <>
      <section className="bg-black text-white py-20"><div className="container-x"><h1 className="font-display text-4xl sm:text-5xl font-bold" data-testid="page-title">{POLICY[k]}</h1></div></section>
      <section className="py-16 bg-white"><div className="container-x max-w-3xl"><div className="text-[#333] leading-relaxed whitespace-pre-line" data-testid="policy-body">{site?.policies?.[k]}</div></div></section>
    </>
  );
}

export { img };
